import { GriffelStyle, makeStyles } from '@fluentui/react-components';
import { useButtonStyles } from './buttonStyles';
import { useTextStyles } from './useTextStyles';
import { useMenuClasses } from './useMenuClasses';
import { useScrollbarClasses } from './useScrollClasses';
import { useDropdownClasses } from './useDropdownClasses';

const flex: GriffelStyle = {
    gap: '1rem',
    display: 'flex',
};
const flexColumn: GriffelStyle = {
    ...flex,
    flexDirection: 'column',
};
const flexRow: GriffelStyle = {
    ...flex,
    flexDirection: 'row',
    flexWrap: 'wrap',
};
const withHiddenChildren: GriffelStyle = {
    '& .hidden': {
        visibility: 'hidden',
    },
    '& .collapse': {
        display: 'none',
    },
    '& .expand': {
        display: 'inline',
    },
    '& .pressed': {
        display: 'none',
    },
    ':hover': {
        '& .hidden': {
            visibility: 'visible',
        },
        '& .collapse': {
            display: 'unset',
        },
        '& .expand': {
            display: 'none',
        },
    },
    ':active': {
        '& .pressed': {
            display: 'unset',
        },
    },
};
const noSelect: GriffelStyle = {
    pointerEvents: 'none',
    userSelect: 'none',
};
const useUtilityStyles = makeStyles({
    withHiddenChildren,
    flex,
    flexColumn,
    flexRow,
    noSelect,
});
const useContainerStyles = makeStyles({
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '110rem',

        '@media (max-width: 1599px)': {
            maxWidth: 'calc(100vw - 270px)',

            '@media (max-width: 1439px)': {
                maxWidth: '1170px',

                '@media (max-width: 1223px)': {
                    maxWidth: 'calc(100vw - 54px)',
                },
            },
        },
    },
});


export const useCommonStyles = () => {
    return {
        utility: useUtilityStyles(),
        container: useContainerStyles(),
        button: useButtonStyles(),
        text: useTextStyles(),
        menu: useMenuClasses(),
        dropdown: useDropdownClasses(),
        scroll: useScrollbarClasses(),
    };
};
